var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"chevron-up"),React.createElement("path",{"d":"M22.13,36.83L7.34,22a1.36,1.36,0,0,1,0-1.92l14.6-14.6","transform":"translate(16.7 -2.77) rotate(90, 12.15, 10.7)","style":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"5.49805142246211px"},"key":1})]);
}

ChevronUp.defaultProps = {"viewBox":"0 0 36.81 20.68"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;



//////////////////
// WEBPACK FOOTER
// ./app/components/setup/chevron-up.svg
// module id = ./app/components/setup/chevron-up.svg
// module chunks = 1